import React from 'react';
import ReactDOM from 'react-dom/client';
import { setContainerStore } from '../@initial/shadowStorage';
import { PageList, pageSource } from '../config/page';
import { getXHRJSON } from './getXHRJSON';
import { RenderModule } from './renderModule';
type IslandConfig =  {useShadowDom?: boolean};
const islandDefaultData = {
  useShadowDom: false,
};
const getIslandManifest = async (origin:string): Promise<IslandConfig> => {
  try {
    const data = (await getXHRJSON(`${origin}/island-manifest.json`) ?? islandDefaultData) as Promise<IslandConfig>;
    return data;
  } catch(e) {
    return islandDefaultData
  }
}
export const pageMountHoc = (page: PageList, children?: React.ReactNode) => {
  return async (mountDom: HTMLElement) => {
    if(!(mountDom instanceof HTMLElement)) {
      throw new Error("mount zone is not HTMLElement");
    }
    const pageInfo = pageSource[page];
    const islandManifest = await getIslandManifest(pageInfo.origin);

    const mountRoot = islandManifest?.useShadowDom ? mountDom.attachShadow({mode: 'open'}) : mountDom;

    const identifierPrefix = pageInfo.scope;
    setContainerStore(identifierPrefix, mountRoot);
    ReactDOM.createRoot(
      mountRoot,
      {
        identifierPrefix: identifierPrefix,
      }
    ).render(
      <RenderModule {...pageInfo} container={mountRoot}>{children}</RenderModule>,
    );
  };
};
